export default "__VITE_ASSET__CNiKyi$T__"